import AlertMsg from "../info/AlertMsg";

const CardContainer = ({ softTitle, mainTitle, description, alerts = [], infoSection = null, className = "mb-3", style = {}, action = null, children, separator = true }) => {
  return (
    <div
      className={`card overflow-hidden ${className}`}
      aria-label="settings-card"
      style={{
        color: "var(--title-color)",
        background: "var(--card-color)",
        border: "1px solid var(--card-secondary-border-color)",
        borderRadius: "18px",
        boxShadow: "0 10px 28px rgba(28, 39, 70, 0.07)",
        ...style,
      }}
    >
      <div
        className="px-3 px-md-4 pt-3 pt-md-4 pb-3"
        style={{
          borderColor: "var(--card-secondary-border-color)",
        }}
      >
        <div className={action ? "d-flex justify-content-between align-items-start gap-3" : undefined}>
          <div>
            <span
              className="d-block mb-1 fw-bold"
              style={{
                color: "var(--primary-color)",
                fontSize: "0.7rem",
                letterSpacing: "0.12em",
              }}
            >
              {softTitle?.toUpperCase()}
            </span>
            <h2 className="h4 mb-1 fw-bold" style={{ color: "var(--title-color)" }}>
              {mainTitle &&
                mainTitle.charAt(0).toUpperCase() + mainTitle.slice(1).toLowerCase()
              }
            </h2>
          </div>
          {action && <div className="flex-shrink-0">{action}</div>}
        </div>
        <p
          className="mb-0"
          style={{
            color: "var(--text-color)",
            fontSize: "0.95rem",
            lineHeight: 1.5,
          }}
        >
          {description}
        </p>
        {alerts.length > 0 && (
          <div className="mt-2">
            {alerts.map(({ type, message }, index) => (
              <AlertMsg key={index} type={type} text={message} />
            ))}
          </div>
        )}
        {infoSection && <div className="mt-2">{infoSection}</div>}
      </div>
      {separator && <hr className="my-0 mx-4" />}
      {children}
    </div>
  );
};

export default CardContainer;